import React, { useRef, useEffect } from 'react';
import { FocusRestorationContext } from '@atlassian/jira-navigation-apps-sidebar-nav4-projects-customise-order/src/controllers/focus-restoration-context.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';

export const Nav4ProjectMenuItemContent = componentWithCondition(
	() => expVal('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
	ContentWithDragAndDrop,
	Content,
);

export type DragAndDropProps = {
	menuItemAnchorRef?: React.RefObject<HTMLAnchorElement>;
	menuItemButtonRef?: React.RefObject<HTMLButtonElement>;
};

export type Nav4ProjectMenuItemContentProps = {
	renderMenuItem: (dragAndDropProps?: DragAndDropProps) => React.JSX.Element;
};

function ContentWithDragAndDrop({ renderMenuItem }: Nav4ProjectMenuItemContentProps) {
	// TODO: Replace with useMenuItemDragAndDrop()
	const menuItemButtonRef = useRef<HTMLButtonElement | null>(null);
	const menuItemAnchorRef = useRef<HTMLAnchorElement | null>(null);

	const shouldRestoreFocusRef = useRef<boolean>(false);

	useEffect(() => {
		if (shouldRestoreFocusRef.current) {
			// .focus() seems to be more reliable in the next task when used with VoiceOver
			setTimeout(() => {
				(menuItemButtonRef.current ?? menuItemAnchorRef.current)?.focus();
				shouldRestoreFocusRef.current = false;
			});
		}
	});

	return (
		<FocusRestorationContext.Provider value={{ shouldRestoreFocusRef }}>
			{renderMenuItem({
				menuItemAnchorRef,
				menuItemButtonRef,
			})}
		</FocusRestorationContext.Provider>
	);
}

function Content({ renderMenuItem }: Nav4ProjectMenuItemContentProps) {
	return <>{renderMenuItem()}</>;
}
